import {
  DriverSettlements,
  GeneralPayablesDetails,
  MaintenancePayablesDetails,
  OrderEntryDetails,
  PrintRenderDetails,
  ProcessExecutionGeneralPayables,
  ProcessExecutionMaintenancePayables,
  ProcessExecutionOrderEntry,
  ProcessExecutionStatus,
  ProcessManagement,
  ProcessManagementDetails,
  ProcessManagementScanningScenario,
  ProcessManagementScanningScenarioOld,
} from 'app/routes/lazyPages';
import ROUTES from 'app/routes/paths';
import { ACCESSIBLE_ROLES } from 'constants/roles';
import { LicensedModule } from 'hocs/accessibleByLicense/typing';
import onlySignedInPage from 'hocs/onlySignedInPage';
import AutomatedIndexingDetails from 'pages/automatedIndexingDetails';
import {
  accessOrDefaultRedirect,
  licenseOrDefaultRedirect,
} from 'utils/accessOrDefaultRedirect';

const executionRoutes: RoutesConfig = [
  {
    path: ROUTES.process.execution._(),
    component: onlySignedInPage(
      accessOrDefaultRedirect(ACCESSIBLE_ROLES.ALL)(ProcessManagement)
    ),
    exact: true,
  },
  {
    path: ROUTES.process.execution.details.printRender._(),
    component: onlySignedInPage(
      accessOrDefaultRedirect(ACCESSIBLE_ROLES.ALL)(PrintRenderDetails)
    ),
    exact: false,
  },
  {
    path: ROUTES.process.execution.details.orderEntry._(),
    component: licenseOrDefaultRedirect(LicensedModule.ORDER_ENTRY)(
      onlySignedInPage(OrderEntryDetails)
    ),
    exact: false,
  },
  {
    path: ROUTES.process.execution.details.maintenancePayables._(),
    component: licenseOrDefaultRedirect(LicensedModule.MAINTENANCE_PAYABLES)(
      onlySignedInPage(MaintenancePayablesDetails)
    ),
    exact: false,
  },
  {
    path: ROUTES.process.execution.details.generalPayables._(),
    component: licenseOrDefaultRedirect(LicensedModule.GENERAL_PAYABLES)(
      onlySignedInPage(GeneralPayablesDetails)
    ),
    exact: false,
  },
  {
    path: ROUTES.process.execution.details.automatedIndexing._(),
    component: licenseOrDefaultRedirect(LicensedModule.AUTOMATED_INDEXING)(
      onlySignedInPage(AutomatedIndexingDetails)
    ),
    exact: false,
  },
  {
    path: ROUTES.process.execution.details.status._(),
    component: onlySignedInPage(
      accessOrDefaultRedirect(ACCESSIBLE_ROLES.ALL)(ProcessExecutionStatus)
    ),
    exact: false,
  },
  {
    path: [
      ROUTES.process.execution.details._(),
      ROUTES.process.execution.details.all._(),
      ROUTES.process.execution.details.all.search(),
      ROUTES.process.execution.details.running._(),
      ROUTES.process.execution.details.running.search(),
      ROUTES.process.execution.details.success._(),
      ROUTES.process.execution.details.success.search(),
      ROUTES.process.execution.details.failed._(),
      ROUTES.process.execution.details.failed.search(),
    ],
    component: onlySignedInPage(
      accessOrDefaultRedirect(ACCESSIBLE_ROLES.ALL)(ProcessManagementDetails)
    ),
    exact: true,
  },
  {
    path: ROUTES.process.scanningScenarioOld(),
    component: onlySignedInPage(
      accessOrDefaultRedirect(ACCESSIBLE_ROLES.ALL)(
        ProcessManagementScanningScenarioOld
      )
    ),
    exact: false,
  },
  {
    path: ROUTES.process.scanningScenario(),
    component: onlySignedInPage(
      accessOrDefaultRedirect(ACCESSIBLE_ROLES.ALL)(
        ProcessManagementScanningScenario
      )
    ),
    exact: false,
  },
  {
    path: ROUTES.process.orderEntry(),
    component: onlySignedInPage(
      accessOrDefaultRedirect(ACCESSIBLE_ROLES.ALL)(
        licenseOrDefaultRedirect(LicensedModule.ORDER_ENTRY)(
          ProcessExecutionOrderEntry
        )
      )
    ),
    exact: false,
  },
  {
    path: ROUTES.process.maintenancePayables(),
    component: onlySignedInPage(
      accessOrDefaultRedirect(ACCESSIBLE_ROLES.ALL)(
        licenseOrDefaultRedirect(LicensedModule.MAINTENANCE_PAYABLES)(
          ProcessExecutionMaintenancePayables
        )
      )
    ),
    exact: false,
  },
  {
    path: ROUTES.process.generalPayables(),
    component: onlySignedInPage(
      accessOrDefaultRedirect(ACCESSIBLE_ROLES.ALL)(
        licenseOrDefaultRedirect(LicensedModule.GENERAL_PAYABLES)(
          ProcessExecutionGeneralPayables
        )
      )
    ),
    exact: false,
  },
  {
    path: ROUTES.process.execution.details.driverSettlements._(),
    component: onlySignedInPage(
      accessOrDefaultRedirect(ACCESSIBLE_ROLES.ALL)(DriverSettlements)
    ),
    exact: false,
  },
];

export { executionRoutes };
